// Updated fetchWorkerManager.ts - Works exactly like your api._get
import { isVpnMode } from "../../../state";
import { fetchSmart } from "../providers/fetchHttpDns";

let cache = new Map<string, { data: any; timestamp: number }>();
const CACHE_EXPIRY = 30 * 60 * 1000; // 30 minutes

const fetchData = async (url: string) => {
  const cached = cache.get(url);
  const now = Date.now();

  // Return cached data if it's still fresh
  if (cached && now - cached.timestamp < CACHE_EXPIRY) {
    console.log("📦 Using cached data for:", url.split("?")[0]);
    return cached.data;
  }

  try {
    console.log("🌐 fetchData starting for:", url.split("?")[0]);

    // Step 1: Apply VPN proxy if enabled (SAME LOGIC AS api._get)
    if (isVpnMode()) {
      const encodedUrl = btoa(url); // Encode original URL to base64
      const proxyUrl = localStorage.getItem("proxy_url");

      if (proxyUrl) {
        const finalUrl = `${proxyUrl}${encodedUrl}`;
        console.log("🔒 VPN mode enabled in fetchData - using proxy");

        const response = await fetch(finalUrl);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        const data = await response.json();
        cache.set(url, { data, timestamp: now });
        console.log("✅ VPN fetch successful:", Array.isArray(data) ? `${data.length} items` : typeof data);
        return data;
      } else {
        console.warn("⚠️ VPN mode enabled but no proxy_url found in localStorage");
      }
    }

    // Step 2: Use fetchSmart for direct requests (SAME LOGIC AS api._get)
    console.log("📞 Using fetchSmart in fetchData for:", url.split("?")[0]);
    const response = await fetchSmart(url);

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    cache.set(url, { data, timestamp: now });
    console.log("✅ fetchSmart successful:", Array.isArray(data) ? `${data.length} items` : typeof data);

    return data;
  } catch (error) {
    console.error("❌ Fetch error for URL:", url.split("?")[0]);
    console.error("❌ Error details:", error);
    throw error;
  }
};

// Clean old cache entries periodically
const cleanCache = () => {
  const now = Date.now();
  for (const [key, value] of cache.entries()) {
    if (now - value.timestamp > CACHE_EXPIRY) {
      cache.delete(key);
    }
  }
  console.log("🧹 Cache cleaned, current size:", cache.size);
};

// Get cache info for debugging
const getCacheInfo = () => {
  return {
    size: cache.size,
    vpnMode: isVpnMode(),
    proxyUrl: localStorage.getItem("proxy_url"),
    keys: Array.from(cache.keys()).map(key => key.split("?")[0]),
  };
};

// Clear specific cache entries
const clearCache = (pattern?: string) => {
  if (pattern) {
    for (const [key] of cache) {
      if (key.includes(pattern)) {
        cache.delete(key);
      }
    }
    console.log(`🗑️ Cleared cache entries matching: ${pattern}`);
  } else {
    cache.clear();
    console.log("🗑️ All cache cleared");
  }
};

// Clean cache every 10 minutes
setInterval(cleanCache, 10 * 60 * 1000);

export { fetchData, getCacheInfo, clearCache };
